import React, { useState, useEffect } from 'react'
import { _formatDateInDash, _preFormatDate } from '../../../../utils/validation'
import moment from 'moment'
import { approveLoanApi, getMonthEmiAmountFrontendLatest } from '../AdminActionCreator.component'
import { APIS } from '../../../../utils/api-factory'
import { STRING } from '../../../../utils/Constant'
import Popup from '../../../presentationals/Popup/Popup.component'
export default function ApproveNewpopup({ nachSourceData, userDetails, admin, allDetail }) {
    const [details, setDetails] = useState({
        appliedAmount: '',
        amountEntered: '',
        date: moment(new Date()).format("YYYY-MM-DD"),
        salaryDay: '',
        installment: '6',
        nbfcId: '',
        mail: true,
        esignDisable: false,
        showCheckBoxEsign: false,
        subStatus: null,
    })
    const [nbfcList,setnbfcList] =useState([])
    const [repeatUserData, setrepeatUserData] = useState({})
    const [paybackDates, setpaybackDates] = useState([])
    const [popup, setpopup] = useState({ show: false, popupStatus: "" })

    useEffect(()=>{
        getNbfcList()
    },[])

    useEffect(() => {
        console.log(allDetail)
        if (allDetail?.userId) {

            setDetails((prev) => ({
                ...prev,
                // appliedAmount: allDetail != null && allDetail.tentativeAmount != null ? allDetail.tentativeAmount : null,
                // amountEntered: allDetail != null && allDetail.tentativeAmount != null ? allDetail.tentativeAmount : null,
                appliedAmount: allDetail != null && allDetail.loanAmount != null ? allDetail.loanAmount : null,
                amountEntered: allDetail != null && allDetail.loanAmount != null ? allDetail.loanAmount : null,
                salaryDay: allDetail.employmentDetailsPO.salaryDay,
                installment: allDetail != null && allDetail?.loanEmi != null ? allDetail?.loanEmi : null
            }))


            fetch(APIS.REPEAT_USER_CHECK + userDetails.userId)
                .then(res => res.json())
                .then(json => {

                    setrepeatUserData(json?.repeatUser)
                    if (json?.repeatUser === true) {
                        fetch(APIS.SHOW_DISABLE_ESIGN + userDetails.userId)
                            .then(res => res.json())
                            .then(json => {
                                if (json !== null && json !== '' && json !== undefined) {
                                    setDetails((prev) => ({
                                        ...prev,
                                        esignDisable: json.esign,
                                        showCheckBoxEsign: json.esign
                                    }))
                                }
                            })
                    }
                })
            // if (allDetail?.tentativeAmount !== null && allDetail?.tentativeAmount !== undefined && allDetail?.tentativeAmount !== "" && allDetail?.loanEmi !== null && allDetail?.loanEmi !== undefined && allDetail?.loanEmi !== "") {
            if (allDetail?.loanAmount !== null && allDetail?.loanAmount !== undefined && allDetail?.loanAmount !== "" && allDetail?.loanEmi !== null && allDetail?.loanEmi !== undefined && allDetail?.loanEmi !== "") {
                getMonthEmiAmountFrontendLatestn(allDetail?.loanAmount, allDetail?.loanEmi)
            }
        }
    }, [allDetail])


    const getMonthEmiAmountFrontendLatestn = (amount, month) => {
        getMonthEmiAmountFrontendLatest(amount, month, allDetail?.userId, allDetail?.productId, callBack => {
            if (Array.isArray(callBack) && callBack.length > 0) {
                const allDates = callBack.map(item => item?.Date).filter(Boolean);
                setpaybackDates(allDates)
            } else {
                setpopup({ show: false, popupStatus: 'Error Fetching Repayment Dates' })
                removePopup()
            }
        })
    }


    const handleclick = () => {
        const obj = {
            approveDate: moment(details?.date).format("DD-MM-YYYY"),
            selectEMI: details?.installment,
            ApproveAmount: details?.amountEntered,
            nbfcId: details?.nbfcId,
            subStatus: details?.subStatus || null,
        }

        approveLoanApi(
            userDetails,
            STRING.APPROVED_STATUS,
            null,
            obj,
            details?.mail,
            null,
            admin?.emailId,
            paybackDates,
            userDetails.loanFrom !== "vreedhi" ? admin?.nbfcName : 'vreedhi',
            admin?.esignDisable,
            callBack => {
                console.log("true",callBack)
                if (callBack === 'success') {
                    setpopup({ show: true, popupStatus: 'Loan Approved Successfully!' })

                } else {
                    setpopup({ show: true, popupStatus: 'Please try again later!' })

                }
                removePopup()
            }
        )
    }

    const handlechange = (e, typ) => {
        if (typ == "installment") {
            getMonthEmiAmountFrontendLatestn(details?.amountEntered, e.target.value)
        }
        setDetails((prev) => ({
            ...prev,
            [typ]: typ == "mail" ? e.target.checked : e.target.value
        }))
    }


    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    function getNbfcList() {
        fetch(APIS.GET_LIST_OF_NBFC)
            .then(res => res.json())
            .then(res => {
                setnbfcList(res)
                
            })
    }


    return (
        <>
            {
                popup?.show ?
                    <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
                    : ''}
            <h4 className='text-center'>Applied Amount : {details?.appliedAmount}</h4>

            <div className="row" style={{ marginTop: '20px' }}>
                <div className="col-sm-6 col-xs-12" style={{ marginTop: '10px' }}>
                    <label htmlFor="">Enter Amount</label>
                    <input type='number'
                        placeholder='Enter Amount'
                        className='form-control'
                        value={details?.amountEntered}
                        max={details?.appliedAmount}
                        onChange={(e) => handlechange(e, "amountEntered")}
                    />
                </div>
                <div className="col-sm-6 col-xs-12" style={{ marginTop: '10px' }}>
                    <label htmlFor="">Select Date</label>
                    <input type='date'
                        placeholder='Enter Amount'
                        className='form-control'
                        value={details?.date}
                        onChange={(e) => handlechange(e, "date")}
                    />
                </div>
                <div className="col-sm-6 col-xs-12" style={{ marginTop: '10px' }}>
                    <label htmlFor="">Salary Date</label>
                    <select
                        className='form-control'
                        value={details?.salaryDay}
                        onChange={(e) => handlechange(e, "salaryDay")}
                    >
                        <option value='1'>1</option>
                        <option value='2'>2</option>
                        <option value='3'>3</option>
                        <option value='4'>4</option>
                        <option value='5'>5</option>
                        <option value='6'>6</option>
                        <option value='7'>7</option>
                        <option value='8'>8</option>
                        <option value='9'>9</option>
                        <option value='10'>10</option>
                        <option value='11'>11</option>
                        <option value='12'>12</option>
                        <option value='13'>13</option>
                        <option value='14'>14</option>
                        <option value='15'>15</option>
                        <option value='16'>16</option>
                        <option value='17'>17</option>
                        <option value='18'>18</option>
                        <option value='19'>19</option>
                        <option value='20'>20</option>
                        <option value='21'>21</option>
                        <option value='22'>22</option>
                        <option value='23'>23</option>
                        <option value='24'>24</option>
                        <option value='25'>25</option>
                        <option value='26'>26</option>
                        <option value='27'>27</option>
                        <option value='28'>28</option>
                        <option value='29'>29</option>
                        <option value='30'>30</option>
                        <option value='31'>31</option>
                    </select>
                </div>
                <div className="col-sm-6 col-xs-12" style={{ marginTop: '10px' }}>
                    <label htmlFor="">Select Installment</label>
                    <select
                        className='form-control'
                        value={details?.installment}
                        onChange={(e) => handlechange(e, "installment")}
                    >
                        <option value='6'>6 Month</option>
                        <option value='12'>12 Month</option>
                        <option value='18'>18 Month</option>
                        <option value='24'>24 Month</option>
                        <option value='30'>30 Month</option>
                        <option value='36'>36 Month</option>
                    </select>
                </div>
                <div className="col-sm-6 col-xs-12" style={{ marginTop: '10px' }}>
                    <label htmlFor="">Select NBFC</label>
                    <select
                        className='form-control'
                        value={details?.nbfcId}
                        onChange={(e) => handlechange(e, "nbfcId")}
                    >
                        <option value=''>Select NBFC</option>
                        {
                            nbfcList?.length > 0 ? nbfcList?.map((value,id)=>{
                                if(value?.isActive == false) return
                                return(
                                    <option value={value?.nbfcId}>{value?.name}</option>
                                )
                            })
                       :"" }
                    </select>
                </div>
                {
                    repeatUserData == true ?
                        <div className="col-sm-6 col-xs-12" style={{ marginTop: '10px' }}>
                            <label htmlFor="">Select Sub Status</label>
                            <select
                                className='form-control'
                                value={details?.subStatus}
                                onChange={(e) => handlechange(e, "subStatus")}
                            >
                                <option value=''>Select Sub Status</option>
                                <option value='201'>PFD</option>
                                <option value='202'>RFD</option>
                            </select>
                        </div>
                        : ''}
            </div>


            <div style={{ marginTop: '50px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input type="checkbox" checked={details?.mail}
                        onChange={(e) => handlechange(e, "mail")}
                        style={{ marginTop: '-2px' }}
                    />&nbsp;&nbsp;
                    <h5 style={{ margin: '0' }}>Send Mail</h5>
                </div>


                <h5 style={{ margin: '10px 0 20px 0' }}>NACH: &nbsp;
                    {userDetails?.nachStatus != null && userDetails?.nachStatus != null ? (
                        userDetails?.nachStatus == true ? (
                            <span className='red-text' style={{ background: '#fff', padding: '5px', borderRadius: '5px' }}>Active -{nachSourceData?.signDesk ? 'Sign Desk' : nachSourceData?.billDesk ? 'Billdesk' : nachSourceData?.razorPay ? (nachSourceData?.razorPay)?.toUpperCase() : nachSourceData?.techProcess ? 'Techprocess' : ''}</span>
                        ) : (
                            <span className='red-text' style={{ background: '#fff', padding: '5px', borderRadius: '5px' }}>Inactive</span>
                        )
                    ) : (
                        ''
                    )}
                </h5>
                <button className='btn btn-primary' onClick={() => handleclick()}>Save</button>
            </div>
        </>
    )
}
